export default __webpack_public_path__ + "static/media/pyszne-light.b4ea2cc3.svg";